import { mdiChevronRight } from '@mdi/js'
import Icon from '@mdi/react'
import { IconProps } from '.'

const ChevronRight = (props: IconProps) => (
    <Icon
        data-testid="IconButton__ForwardButton"
        path={mdiChevronRight}
        size={1}
        {...props}
    />
)

export default ChevronRight
